module.exports = __webpack_public_path__ + "assets/cancel.bdc094a7.svg";